import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ITSupportDashboard from './ITSupportDashboard';
import TicketSystem from './components/tickets/TicketSystem';
import AssetManagement from './components/assets/AssetManagement';
import Documentation from './components/docs/Documentation';

const ITSupport = () => {
  return (
    <Routes>
      <Route index element={<ITSupportDashboard />} />
      <Route path="tickets/*" element={<TicketSystem />} />
      <Route path="assets/*" element={<AssetManagement />} />
      <Route path="docs/*" element={<Documentation />} />
    </Routes>
  );
};

export default ITSupport;
